export const regexes = {
    insureNetDateFormat: /^((0[1-9])|([1-2][0-9])|(3[0-1]))\.((0[1-9])|(1[0-2]))\.[1-2][0-9]{3}$/,
};
